<template>
  <div class="full-page-width relative locations">
    <ConfirmationBar
      :showSavebar="showSavebar"
      @confirm="submitAutomationForm"
      @cancel="cancelAutomationSave"
    />
    <div class="add-button c-float m-b-25">
      <div class="flex-center float-left">
        <Btn
          @click.native="routeIt"
          class="light bordered empty d-inline-block m-r-15 fix-40"
          :icon="{
            name: 'arrowLeftBig',
            size: '20',
          }" />
        <p class="user-name" v-if="get_automation">{{ `${get_automation.name}` }}</p>
      </div>
    </div>
    <!-- HEADER -->
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('general')"
          :text="$t('automation-info-text')"
          :btnText="$t('delete')"
          btnType="red"
          btnIcon="deleteForever"
          @action="toggleDeleteAutomationPopup" />
      </div>
      <div class="col-xs-8" v-if="get_automation !== null">
        <div class="card">
          <InputSelect
            v-if="get_user.is_admin"
            class="m-b-40"
            :multiSelect=true
            :preselected="automationForm.accessible_for_subaccounts"
            :label="$t('accessible_for_accounts')"
            @change="selectAccessibleSubaccount"
            :options="getAllowedSubaccounts"/>
          <div class="toggle-card m-b-30">
            <div>
              <span class="title">{{ $t('status') }}</span>
              <span class="additional-info">{{ `${$t('enable')} ${$t('automations')}` }}</span>
            </div>
            <Toggle
              id="automationIsActive"
              v-model="isAutomationActive" />
          </div>
          <InputText
            :label="$t('name')"
            v-model="automationForm.name"/>
        </div>
      </div>
    </div>
    <div class="separator"></div>
    <!-- BODY -->
    <div class="row">
      <div class="col-xs-4 text-box">
        <InfoTextBox
          :title="$t('actions')"
          :text="$t('actions_subtext')"
          :btnText="$t('add_action')"
          @action="toggleActionsPopup" />
      </div>
      <div class="col-xs-8">
        <ul class="list-table">
          <li
            class="list-table-item"
            @click="openEditActionPopup(item.id)"
            v-for="(item, index) in get_automation_actions.items" :key="`action-item-${index}`">
            <div class="table-cell">
              <p>
                <span class="main-info">
                  {{ `${item.user_name || item.name || '-'}` }}
                </span>
                <span class="additional-info">
                  {{ $t(item.type) }}
                </span>
              </p>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <Popup
      v-if="openDeleteAutomationPopup"
      :popupSmall=true
      min-height="150px"
      :showDeleteButton="true"
      :showConfirmButton="false"
      @cancel="toggleDeleteAutomationPopup"
      @deleteAction="submitDeleteAutomation">
      <template v-slot:header>
        <h2>{{ $t('delete') }}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12">
            <p>{{ $t('are_you_sure_delete_text')}}</p>
          </div>
        </div>
      </div>
    </Popup>
    <Popup
      v-if="openActionsPopup"
      :popupMedium=true
      min-height="300px"
      :showConfirmButton="!deleteAction"
      :showDeleteButton="deleteAction"
      @cancel="toggleActionsPopup"
      @deleteAction="submitDeleteAction"
      @confirm="submitActionsForm">
      <template v-slot:header>
        <h2>{{ $t('add_action') }}</h2>
      </template>
      <div>
        <div class="row">
          <div class="col-xs-12" v-if="!isApiUsernameType">
            <InputText
              class="m-b-20"
              :label="$t('name')"
              v-model="actionForm.name"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-12">
            <InputSelect
              class="m-b-20"
              :multiSelect=false
              :label="$t('action_type')"
              v-model="actionForm.type"
              :options="getActionTypeOptions"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-12" v-if="actionForm.type === 'shipping_product'">
            <InputSelect
              class="m-b-20"
              :multiSelect=false
              :label="$t('shipping_agents')"
              v-model="shippingAgentId"
              :options="get_shipping_agents_select"
              @change="setShippingProducts"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-12 m-b-20">
            <InputSelect
              v-if="showActionValueInputSelect"
              class="m-b-20"
              :multiSelect=false
              :label="$t('value')"
              v-model="actionForm.value"
              :options="getActionValueOptions"
              @change="getAvailableOptions"
              :rules="{required: true}"/>
            <InputText
              v-else
              :label="$t('value')"
              v-model="actionForm.value"
              :rules="{required: true}"/>
          </div>
          <div class="col-xs-12" v-if="actionForm.type === 'shipping_product' && actionForm.value">
            <InputSelect
              :multiSelect=true
              class="m-b-20"
              :label="$t('Select service')"
              :preselected="selectedProductServices"
              @change="selectShippingProductServices"
              :options="availableSelectOptions"
            />
          </div>
        </div>
        <div class="row" v-if="showAndConditionDiv">
          <div class="col-xs-12 m-b-20">
            <p>{{ $t('meet_all_conditions')}}</p>
          </div>
          <div
            style="padding: 0"
            class="col-xs-12"
            v-for="(item, index) in andConditions" :key="`and-condition-${index}`">
            <div class="col-xs-4 m-b-20">
              <InputSelect
                class="m-b-20"
                :multiSelect=false
                :label="$t('condition')"
                v-model="andConditions[index].match_field"
                :options="getMatchFieldOptions()"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-3 m-b-20">
              <InputSelect
                class="m-b-20"
                :multiSelect=false
                :label="$t('operator')"
                v-model="andConditions[index].operator"
                :options="getOperatorOptions()"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-4 m-b-20">
              <InputSelect
                v-if="showMatchAgainstInputSelect"
                class="m-b-20"
                :multiSelect=false
                :label="$t('match_against')"
                v-model="andConditions[index].match_against"
                :options="getMatchAgainstOptions()"
                :rules="{required: true}"/>
              <InputText
                v-else
                :label="$t('match_against')"
                v-model="andConditions[index].match_against"
                :rules="{required: true}" />
            </div>
            <div class="col-xs-1">
              <Btn
                style="margin-top: 25px; padding: 12px 22px; margin-left: -6px"
                @click.native="removeAndCondition(index, item)"
                class="gray"
                position="icon-pos-center"
                :icon="{
                    name: 'deleteForever',
                    size: '18',
                  }"
              />
            </div>
          </div>
          <div class="col-xs-12" v-if="showAddAndConditionButton">
            <Btn
              @click.native="addAndCondition"
              class="brand float-left"
              :icon="{
                name: 'plus',
                size: '18',
              }"
              :btnText="$t('add_condition')" />
          </div>
        </div>
        <div class="row" v-if="showOrConditionDiv">
          <div class="separator medium"></div>
          <div class="col-xs-12 m-b-20">
            <p>{{ $t('meet_any_condition')}}</p>
          </div>
          <div
            style="padding: 0"
            class="col-xs-12"
            v-for="(item, index) in orConditions" :key="`or-condition-${index}`">
            <div class="col-xs-4 m-b-20">
              <InputSelect
                class="m-b-20"
                :multiSelect=false
                :label="$t('condition')"
                v-model="orConditions[index].match_field"
                :options="getMatchFieldOptions()"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-3 m-b-20">
              <InputSelect
                class="m-b-20"
                :multiSelect=false
                :label="$t('operator')"
                v-model="orConditions[index].operator"
                :options="getOperatorOptions()"
                :rules="{required: true}"/>
            </div>
            <div class="col-xs-4 m-b-20">
              <InputSelect
                v-if="showMatchAgainstInputSelect"
                class="m-b-20"
                :multiSelect=false
                :label="$t('match_against')"
                v-model="orConditions[index].match_against"
                :options="getMatchAgainstOptions()"
                :rules="{required: true}"/>
              <InputText
                v-else
                :label="$t('match_against')"
                v-model="orConditions[index].match_against"
                :rules="{required: true}" />
            </div>
            <div class="col-xs-1">
              <Btn
                style="margin-top: 25px; padding: 12px 22px; margin-left: -6px"
                @click.native="removeOrCondition(index, item)"
                class="gray"
                position="icon-pos-center"
                :icon="{
                    name: 'deleteForever',
                    size: '18',
                  }"
              />
            </div>
          </div>
          <div class="col-xs-12">
            <Btn
              @click.native="addOrCondition"
              class="brand float-left"
              :icon="{
                name: 'plus',
                size: '18',
              }"
              :btnText="$t('add_condition')" />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 p-b-20" v-if="isEdit">
            <div class="separator medium"></div>
            <div class="flex-center toggle-title">
              <div>
                <p>{{ $t('delete') }}</p>
                <span>{{ $t('action_will_be_deleted') }}</span>
              </div>
              <div>
                <Toggle color="red" id="delete" v-model="deleteAction" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Popup>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import LogosSVG from "@/assets/images/logosSVG";
import DataTable from '@/components/table/index.vue';
import Btn from '@/components/elements/buttons';
import Dropdown from '@/components/global/dropdown';
import date from '@/mixins/date';
import Popup from '@/components/global/popup';
import InputSelect from '@/components/elements/inputs/select.vue';
import InputText from '@/components/elements/inputs/text.vue';
import AddressPicker from "@/components/global/addressPicker/index.vue";
import Calendar from '@/components/elements/inputs/calendar.vue';
import mixin from '@/mixins/mixins.js';
import formValidator from '@/mixins/formValidator';
import InfoTextBox from '@/components/global/infoTextBox';
import Toggle from '@/components/elements/inputs/toggle.vue';
import ConfirmationBar from '@/components/global/confirmationBar';

export default {
  name: 'Automation',
  components: {
    LogosSVG,
    DataTable,
    Btn,
    Dropdown,
    Popup,
    InputSelect,
    InputText,
    AddressPicker,
    Calendar,
    InfoTextBox,
    Toggle,
    ConfirmationBar
  },
  mixins: [date, mixin, formValidator],
  data() {
    return {
      availableSelectOptions: [],
      shippingAgentId: null,
      shippingProducts: [],
      selectedProductServices: [],
      showSavebar: false,
      savebarEnabled: false,
      updateIterator: 1,
      deleteAction: false,
      openActionsPopup: false,
      openAutomationPopup: false,
      openDeleteAutomationPopup: false,
      isEdit: false,
      isAutomationActive: false,
      editActionId: '',
      totalCount: 300,
      andConditions: [],
      orConditions: [],
      actionForm: {
        name: '',
        type: '',
        value: '',
      },
      automationForm: {
        name: '',
        status: '',
        active_from: '',
        accessible_for_subaccounts: []
      },
      timeStamps: [
        '06:00', '06:15', '06:30', '06:45',
        '07:00', '07:15', '07:30', '07:45',
        '08:00', '08:15', '08:30', '08:45',
        '09:00', '09:15', '09:30', '09:45',
        '10:00', '10:15', '10:30', '10:45',
        '11:00', '11:15', '11:30', '11:45',
        '12:00', '12:15', '12:30', '12:45',
        '13:00', '13:15', '13:30', '13:45',
        '14:00', '14:15', '14:30', '14:45',
        '15:00', '15:15', '15:30', '15:45',
        '16:00', '16:15', '16:30', '16:45',
        '17:00', '17:15', '17:30', '17:45',
        '18:00', '18:15', '18:30', '18:45',
        '19:00', '19:15', '19:30', '19:45',
        '20:00',
      ],
    };
  },
  computed: {
    ...mapGetters([
      'get_users',
      'get_user',
      'get_filters_menu',
      'get_active_filter',
      'get_automation',
      'get_automation_entity',
      'get_automation_actions',
      'get_automation_action_by_id',
      'get_subaccounts',
      'get_printers',
      'get_shipping_agents_select',
      'get_goods_type_options',
      'get_shippers',
      'get_all_packaging_options'
    ]),
    getAllowedSubaccounts() {
      return this.get_subaccounts.filter((acc) => this.get_user.accessible_subaccounts_array.indexOf(String(acc.id)) > -1).map((acc) => ({text: acc.name, value: String(acc.id),}));
    },
    showAddAndConditionButton() {
      if ((this.andConditions.length > 0)
        && (['api_username', 'printer_name', 'shipping_product', 'goods_type', 'packaging', 'sender_id', 'sender_waybill_address_id', 'sender_vat', 'customer_vat'].includes(this.actionForm.type))) {
        return false;
      }

      return true;
    },
    isApiUsernameType() {
      return this.get_automation.type === 2;
    },
    isShipmentDefaultType() {
      return this.get_automation.type === 6;
    },
    isFTPType() {
      return this.get_automation.type === 7;
    },
    getAutomationTypeName() {
      //If automation object is empty just return
      if (!this.get_automation) return;

      return this.get_automation_entity.types[this.get_automation.type];
    },
    showAndConditionDiv() {
      let condition = true;
      const actionType = this.actionForm.type;
      const conditionTypes = this.get_automation_actions.entity.condition_type[actionType];

      if (this.isApiUsernameType || this.isFTPType || !conditionTypes) {
        condition = false;
      }

      return condition;
    },
    showOrConditionDiv() {
      const actionType = this.actionForm.type;
      const conditionTypes = this.get_automation_actions.entity.condition_type[actionType];

      return !!conditionTypes;
    },
    showActionValueInputSelect () {
      return ['api_username', 'printer_name', 'pickup_time_from', 'pickup_time_until', 'shipping_product', 'goods_type', 'sender_id', 'sender_waybill_address_id', 'packaging', 'incoterms'].includes(this.actionForm.type);
    },
    showMatchAgainstInputSelect () {
      return false;
    },
    getActionValueOptions() {
      let options = [];

      if (this.actionForm.type === 'api_username') {
        options = [
          ...this.get_users.items.map((val, index) => {
            return {value: val.id, text: `${val.first_name} ${val.last_name}`}
          })
        ];
      } else if (this.actionForm.type === 'printer_name') {
        options = [
          ...this.get_printers.items.map((val, index) => {
            return {value: val.id, text: `${val.name}`}
          })
        ];
      } else if (this.actionForm.type === 'shipping_product') {
        options = this.shippingProducts;
      } else if (this.actionForm.type === 'pickup_time_from' || this.actionForm.type === 'pickup_time_until') {
        options = this.timeStamps.map((val, index) => {
          return {value: val, text: val}
        })
      } else if (this.actionForm.type === 'goods_type') {
        options = this.get_goods_type_options;
      } else if (this.actionForm.type === 'sender_id' || this.actionForm.type === 'sender_waybill_address_id') {
        options = this.get_shippers.map((val, index) => {
          return {value: val.id, text: val.company_name ? val.company_name : val.name}
        })
      } else if (this.actionForm.type === 'packaging') {
        options = this.get_all_packaging_options;
      } else if (this.actionForm.type === 'incoterms') {
        options = this.getIncotermOptions
      }

      return options;
    },
    getActionTypeOptions() {
      const automationType = this.get_automation.type;
      const actionTypes    = this.get_automation_actions.entity.type[automationType];

      if (!actionTypes) {
        return [];
      }

      return [
        ...Object.keys(actionTypes).map((val, index) => {
          return {value: val, text: `${actionTypes[val]}`}
        })
      ];
    },
    isPopupSubmitDisabled() {
      let formWithValidators = [
      ];

      return this.validateInput(formWithValidators);
    },
  },
  created() {
    this.automationId = this.$route.params.id;
    //Calls can be optimized if needed
    this.$store.dispatch('GET_AUTOMATION', this.automationId).then((resp) => {
      const automation = resp.items;
      this.isAutomationActive = this.get_automation.status == 2; //If status is active, activate toggle
      this.automationForm.name = this.get_automation.name;
      this.automationForm.accessible_for_subaccounts = this.get_automation.accessible_for_subaccounts;
      this.$store.dispatch('GET_AUTOMATION_ACTIONS', {id: this.automationId})
      this.$store.dispatch('GET_USERS');
      this.$store.dispatch('GET_PRINTERS');
      this.shippingAgentId = automation.shipping_agent_id;
      this.$store.dispatch('GET_SHIPPING_AGENTS');
      this.$store.dispatch('GET_ALL_PACKAGING_OPTIONS');
      this.$store.dispatch('GET_SHIPPERS');

      this.$nextTick(() => {
        this.savebarEnabled = true;
      })
    })
  },
  methods: {
    setShippingProducts(val) {
      this.shippingProducts = [];
      this.$store.dispatch('GET_SHIPPING_PRODUCTS', {agentId: val}).then((res) => {
        res.forEach((item) => {
          this.shippingProducts.push({
            text: item.product_name,
            value: item.shipping_product_id,
          });
        });
      });
    },
    getAvailableOptions(shippingProductId) {
      this.availableSelectOptions = []

      if (this.actionForm.type === 'shipping_product' && shippingProductId) {
        this.$store.dispatch('GET_ALL_AVAILABLE_SERVICE_FOR_SHIPPING_PRODUCT', {shipping_product_id: parseInt(shippingProductId)}).then((res) => {
          res.forEach((fee) => {
            this.availableSelectOptions.push({
              text: fee.name,
              value: String(fee.fee_wrapper_id)
            });
          });
        })
      }

      return this.availableSelectOptions
    },
    selectShippingProductServices(val) {
        this.selectedProductServices = val;
    },
    selectAccessibleSubaccount(val) {
        this.automationForm.accessible_for_subaccounts = val;
    },
    getIconNameByType(type) {
      const names = {
        'api_username': 'single',
      };

      return names[type.toString()];
    },
    getMatchFieldOptions() {
      const actionType = this.actionForm.type;
      const conditionTypes = this.get_automation_actions.entity.condition_type[actionType];

      if (!conditionTypes) {
        return [];
      }

      return [
        ...Object.keys(conditionTypes).map((val, index) => {
          return {value: val, text: `${conditionTypes[val]}`}
        })
      ]
    },
    getMatchAgainstOptions() {
      return [];
    },
    getOperatorOptions () {
      let options = [];

      if (['api_username', 'printer_name', 'shipping_product', 'goods_type', 'packaging', 'sender_id', 'sender_waybill_address_id', 'incoterms', 'sender_vat', 'customer_vat', 'pickup_time_from', 'pickup_time_until', 'colli_weight_kg', 'colli_height_cm', 'colli_length_cm', 'colli_width_cm', 'hs_code'].includes(this.actionForm.type)) {
        options = [
          {
            text: this.$t('equal_to'),
            value: 'equal_to'
          },
          {
            text: this.$t('not_equal_to'),
            value: 'not_equal_to'
          },
          {
            text: this.$t('greater_than'),
            value: 'greater_than'
          },
          {
            text: this.$t('less_than'),
            value: 'less_than'
          },
          {
            text: this.$t('greater_than_or_equal_to'),
            value: 'greater_than_or_equal_to'
          },
          {
            text: this.$t('less_than_or_equal_to'),
            value: 'less_than_or_equal_to'
          },
          {
            text: this.$t('contains'),
            value: 'contains'
          }
        ]
      }

      return options;
    },
    addAndCondition() {
      this.andConditions.push({
        match_field: '',
        operator: 'equal_to',
        match_against: ''
      });
    },
    addOrCondition() {
      this.orConditions.push({
        match_field: '',
        operator: 'equal_to',
        match_against: ''
      });
    },
    removeAndCondition(index, item) {
      this.andConditions.splice(index, 1);
    },
    removeOrCondition(index, item) {
      this.orConditions.splice(index, 1);
    },
    getStatus(statusId) {
      if (statusId == 1) {
        return 'draft';
      } else if (statusId == 2) {
        return 'active';
      } else if (statusId == 3) {
        return 'expired';
      } else if (statusId == 4) {
        return 'pending'
      }
    },
    color(status) {
      if (status == 1) {
        return '';
      } else if (status == 2) {
        return '#60D27C';
      } else if (status == 3) {
        return 'red';
      } else if (status == 4) {
        return '#FFCB52';
      }
    },
    rowAction(val) {
      this.openEditActionPopup(val)
    },
    submitDeleteAction() {
      this.$store.dispatch('DELETE_AUTOMATION_ACTIONS', {automation_id: this.$route.params.id, id: this.editActionId}).then(() => {
        this.toggleActionsPopup();
        this.$store.dispatch('GET_AUTOMATION_ACTIONS', {id: this.$route.params.id});
      });
    },
    submitDeleteAutomation() {
      this.$store.dispatch('DELETE_AUTOMATION', {id: this.$route.params.id}).then(() => {
        this.toggleDeleteAutomationPopup();
        this.$router.go(-1);
      });
    },
    submitAutomationForm() {
      this.$store.dispatch('EDIT_AUTOMATION', {
        id: this.$route.params.id,
        form: {
          name: this.automationForm.name,
          type: this.get_automation.type,
          status: this.isAutomationActive ? '2' : '1', //2 = active, 1 = draft
          active_from: new Date(), //this.automationForm.active_from,
          accessible_for_subaccounts: this.automationForm.accessible_for_subaccounts
        }
      }).then(() => {
        this.$store.dispatch('GET_AUTOMATION', this.$route.params.id)
        this.showSavebar = false;
      });
    },
    submitActionsForm() {
      let action = 'CREATE_AUTOMATION_ACTION';
      let payload = {
        automation_id: this.$route.params.id,
        form: {
          ...this.actionForm,
          and_conditions_json: this.andConditions,
          or_conditions_json: this.orConditions,
          additional_json: this.formatAdditional()
        }
      };

      if (this.isEdit) {
        action = 'EDIT_AUTOMATION_ACTION';
        payload.id = this.editActionId;
      }

      this.$store.dispatch(action, payload).then((res) => {
        this.toggleActionsPopup();
        this.$store.dispatch('GET_AUTOMATION_ACTIONS', {id: this.$route.params.id, page: 1});
      }).catch((e) => {
        this.toggleActionsPopup();
        console.log(e.message)
      })
    },
    toggleActionsPopup() {
      this.openActionsPopup = !this.openActionsPopup;
      this.isEdit = false;
      this.deleteAction = false;
      this.resetActionForm();
    },
    cancelAutomationSave() {
      this.showSavebar = false;
    },
    toggleDeleteAutomationPopup() {
      this.openDeleteAutomationPopup = !this.openDeleteAutomationPopup;
    },
    openEditActionPopup(id) {
      this.toggleActionsPopup();
      this.isEdit = true;
      const data = this.get_automation_action_by_id(id);
      if (!data) {
        return;
      }
      this.shippingAgentId = data.shipping_agent_id;
      this.editActionId = id;
      this.actionForm = {
        name: data.name,
        type: data.type,
        value: data.value,
      };
      this.andConditions = data.and_conditions;
      this.orConditions  = data.or_conditions;

      if (this.shippingAgentId) {
        this.setShippingProducts(this.shippingAgentId);
      }

      if (data.type === 'shipping_product' && data.additional.fee_wrapper) {
        this.getAvailableOptions(parseInt(data.value))
        data.additional.fee_wrapper.forEach((feeWrapper) => {
          this.selectedProductServices.push(feeWrapper.id)
        })
      }
    },
    resetActionForm() {
      this.selectedProductServices = [];
      this.editActionId = '';
      this.shippingAgentId = null;
      this.actionForm = {
        name: '',
        type: '',
        value: '',
      };
      this.andConditions = [];
      this.orConditions  = [];
    },
    actionOptionTriggered(val) {
      if (val.dropOption == 'dropOption1') {
      }
      if(val.dropOption == 'dropOption2') {
      }
    },
    routeIt() {
      this.$router.go(-1);
    },
    formatAdditional() {
      let additional = {"fee_wrapper":[]}
      if (this.actionForm.type === 'shipping_product' && this.selectedProductServices.length) {
        this.selectedProductServices.forEach((feeWrapperId) => {
          additional['fee_wrapper'].push({id: feeWrapperId});//object for later to add default values
        });
      }

      return additional
    },
  },
  destroyed() {
    this.$store.dispatch('CLEAR_AUTOMATION');
    this.$store.dispatch('CLEAR_AUTOMATION_ACTIONS');
  },
  watch: {
    'automationForm.accessible_for_subaccounts': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'automationForm.name': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
    'isAutomationActive': {
      handler(){
        if(this.savebarEnabled){
          this.showSavebar = true;
        }
      },
      deep: true
    },
  }
}
</script>
